import React, { useEffect, useMemo, useState } from "react";
import { ToastContainer, toast } from "react-toastify";
import { useTable, usePagination } from "react-table";
import {
  FaAngleDoubleLeft,
  FaAngleDoubleRight,
  FaAngleLeft,
  FaAngleRight,
  FaPencilAlt,
  FaThumbsUp,
  FaThumbsDown,
  FaTrashAlt,
  FaBan,
  FaPlus,
  FaEye
} from "react-icons/fa";
import { IoCallOutline, IoSettingsSharp } from "react-icons/io5";
import { FaCheckToSlot, FaPersonCircleQuestion, FaStar } from "react-icons/fa6";
import { PiDevicesFill } from "react-icons/pi";
import { TbBrandBooking, TbCircleLetterAFilled, TbThumbUpOff } from "react-icons/tb";
import { BsFuelPumpFill, BsSortNumericDown } from "react-icons/bs";
import { FaTruckDroplet } from "react-icons/fa6";
import { FaComments } from "react-icons/fa";
import { FcViewDetails } from "react-icons/fc";
import {
  ACTION_FIRST,
  ACTION_LAST,
  ACTION_NEXT,
  ACTION_PREV,
} from "../../constants";
// import { useSelector } from "react-redux";
import { SESSION_DATA } from "../../constants";
import { MdAddCall } from "react-icons/md";
import { HiOutlinePhoneMissedCall } from "react-icons/hi";

export default function Table({
  tableColumns,
  tableData,
  tableSettings = {
    page: 0,
    pageSize: 25,
    totalCount: 0,
  },
  action = false,
  modulePermissions = {
    canAdd: false,
    canEdit: false,
    canDelete: false,
    canDownload: false,
  },
  handleStatus,
  handleEdit,
  handleFieldOrder,
  handlePage,
  handleViewReport,
  handleLogDownload,
  handleClickDownloadFlag = false,
  handleFieldOrderFlag = false,
  handleReportFlag = false,
  handleViewDetails = false,
  handlePaginationButtons = true, //false to not show pagination buttons by default true
  handleExpAvalFlag = false,
  handleExpAvailability,
  handleUserBookSlotFlag = false,
  handleUserBookSlot,
  handleExpBookedSlotFlag = false,
  handleExpBookedSlot,
  handleViewBookedSlotFlag = false,
  handleViewBookedSlot,
  handleCallConnectFlag = false,
  handleUserQueryFlag = false,
  handleCallConnectData,
  handleUserQuery,
  handleSlotBookingFlag = false,
  handleSlotBooking ,
  handleUserReviewFlag = false,
  handleUserReview
}) {
  const [canPrev, setCanPrev] = useState(false);
  const [canNext, setCanNext] = useState(false);
  // const { SESSION_DATA } = useSelector((state) => state.user);
  const lowerLimit =
    parseInt(tableSettings.page) * parseInt(tableSettings.pageSize)
      ? parseInt(tableSettings.page) * parseInt(tableSettings.pageSize)
      : 1;
  const upperLimit =
    tableSettings.page + 1 > 0
      ? (tableSettings.page + 1) * tableSettings.pageSize
      : 1;
  const totalLimit = tableSettings.totalCount ? tableSettings.totalCount : 0;

  const columns = useMemo(
    () =>
      tableColumns.map((item) => {
        return {
          Header: item.fieldDisplayName,
          // accessor: item.fieldName,
          accessor: handleReportFlag
            ? `${item.populateOn}${item.order}${item.fieldName}`
            : item.fieldName,
        };
      }),
    [tableColumns]
  );

  const data = useMemo(() => tableData, [tableData]);

  const {
    getTableProps,
    getTableBodyProps,
    headerGroups,
    page,
    setPageSize,
    prepareRow,
  } = useTable(
    {
      columns,
      data,
      initialState: {
        pageSize: tableSettings.pageSize,
      },
    },
    usePagination
  );

  const handlePageChange = (changeType) => {
    let temp = 0;
    if (tableSettings.pageSize < tableSettings.totalCount) {
      temp = Math.ceil(tableSettings.totalCount / tableSettings.pageSize) - 1;
    }

    switch (changeType) {
      case ACTION_PREV:
        if (page === 0) return;
        handlePage((prev) => prev - 1);
        break;
      case ACTION_NEXT:
        if (page >= temp) return;
        handlePage((prev) => prev + 1);
        break;
      case ACTION_FIRST:
        if (page === 0) return;
        handlePage(0);
        break;
      case ACTION_LAST:
        if (page === temp) return;
        handlePage(temp);
        break;
    }
  };

  useEffect(() => {
    if (tableSettings.totalCount >= tableSettings.pageSize) {
      if (tableSettings.page === 0) {
        setCanPrev(false);
        setCanNext(true);
      } else if (
        tableSettings.totalCount >
        tableSettings.pageSize * (tableSettings.page + 1)
      ) {
        setCanPrev(true);
        setCanNext(true);
      } else {
        setCanPrev(true);
        setCanNext(false);
      }
    } else {
      setCanPrev(false);
      setCanNext(false);
    }

    setPageSize(tableSettings.pageSize);
  }, [tableSettings]);

 

  return (
    <div className= "table-responsive border-navy-blue bg-white rounded-10">
      <div className={`${handlePaginationButtons?"table-body":"table-body-modal"}`}>
        <table {...getTableProps()}>
          <thead >
            {headerGroups.map((headerGroup) => (
              <tr {...headerGroup.getHeaderGroupProps()} >
                {headerGroup.headers.map((column) => (
                  <th {...column.getHeaderProps()} className="bg-navyBlue">
                    {column.render("Header")}
                  </th>
                ))}

                {/* Adding Action Header */}
                {(handleViewDetails|| action || handleClickDownloadFlag) && (
                  <th className="bg-navyBlue">{handleViewDetails?"View Report":'Action'}</th>
                )}
              

              </tr>
            ))}
          </thead>
          {tableData?.length > 0 ? (
            <tbody {...getTableBodyProps()}>
              {page.map((row, rowIndex) => {
                prepareRow(row);
                return (
                  <tr {...row.getRowProps()}>
                    {row.cells.map((cell) => (
                      <td
                        {...cell.getCellProps()}
                        className={
                          isNaN(parseFloat(cell.value))
                            ? "text-left"
                            : "text-left"
                        }
                      >
                        {cell.render("Cell")}
                      </td>
                    ))}
                    {/* Adding Action Buttons */}
                    {action && (
                      <td>
                        <div className="btn-wrapper no-wrap">
                         
                          {handleExpAvalFlag 
                          
                          ? (
                            <button
                              onClick={() => handleExpAvailability(rowIndex)}
                              className="border-white no-bg  text-navyBlue"
                            >
                              <TbCircleLetterAFilled title="Manage Slots Availability" />
                            </button>
                          ) : (
                            ""
                          )}
                          {handleExpBookedSlotFlag 
                          
                          ? (
                            <button
                              onClick={() => handleExpBookedSlot(rowIndex)}
                              className="border-white no-bg  text-secondary"
                            >
                              <FaCheckToSlot title="Manage Slots Booking" />
                            </button>
                          ) : (
                            ""
                          )}
                          {handleViewBookedSlotFlag 
                          
                          ? (
                            <button
                              onClick={() => handleViewBookedSlot(rowIndex)}
                              className="border-white no-bg  text-green"
                            >
                              <FaEye title="View Slot Booking" />
                            </button>
                          ) : (
                            ""
                          )}
                          {handleCallConnectFlag 
                          
                          ? (
                            <button
                              onClick={() => handleCallConnectData(rowIndex)}
                              className="border-white no-bg "
                            >
                               {tableData[rowIndex].callConnFlag === true ? (
                              <IoCallOutline  title="Connect Call" className="text-green" />
                            ) : (
                              <HiOutlinePhoneMissedCall  title="Call Connect is Disabled" className="text-red"/>
                                )}
                            </button>
                          ) : (
                            ""
                          )}
                          {handleUserQueryFlag 
                          
                          ? (
                            <button
                              onClick={() => handleUserQuery(true,rowIndex)}
                              className="border-white no-bg "
                            >
                              <FaPersonCircleQuestion  title="View Query" className="text-blue" />
                            </button>
                          ) : (
                            ""
                          )}
                          {handleUserBookSlotFlag 
                          
                          ? (
                            <button
                              onClick={() => handleUserBookSlot(rowIndex)}
                              className="border-white no-bg text-grey"
                            >
                              <TbBrandBooking title="Manage User Slot Booking" />
                            </button>
                          ) : (
                            ""
                          )}
                          {handleUserReviewFlag 
                          
                          ? (
                            <>
                            
                            <button
                              onClick={() => handleUserReview(rowIndex)}
                              // className="border-gray bg-LightGray-pointer text-grey"
                               className="btn btn-sm btn-light-pink rounded-10"
                               title="Click To View User Review "
                            >
                           <FaStar  />
                           <FaStar  />
                           <FaStar  />
                           <FaStar  />
                            </button>
                            
                            </>
                            
                          ) : (
                            ""
                          )}
                          
                          {handleSlotBookingFlag 
                          
                          ? (
                            <button
                              onClick={() => handleSlotBooking(rowIndex)}
                              // className="border-gray bg-LightGray-pointer text-grey"
                               className="btn btn-sm btn-green rounded-10"
                               title="Book Slot Now"
                            >
                             Book Now {/* <TbBrandBooking title="Book Slot Now" /> */}
                            </button>
                          ) : (
                            ""
                          )}
                          
                         

                          {modulePermissions.canEdit && (
                            <button
                              onClick={() => handleEdit(rowIndex)}
                              className="border-white no-bg text-blue"
                            >
                              <FaPencilAlt title="Edit" />
                            </button>
                          )}

                          {handleFieldOrderFlag && modulePermissions.canEdit ? (
                            <button
                              onClick={() => handleFieldOrder(rowIndex)}
                              className="border-white no-bg text-pink"
                            >
                              <BsSortNumericDown title="Manage Fields Order" />
                            </button>
                          ) : (
                            ""
                          )}
                          {modulePermissions.canEdit  ? (
                            
                              <button
                                onClick={() =>
                                  handleStatus(
                                    tableData[rowIndex]?._id,
                                    rowIndex,
                                    true
                                  )
                                }
                                className="border-white no-bg text-black"
                              >
                                {tableData[rowIndex].status === "A" ? (
                                  <FaThumbsUp
                                    title="Status Active"
                                    className="text-green"
                                  />
                                ) : (
                                  <FaThumbsDown
                                    title="Status Inactive"
                                    className="text-grey"
                                  />
                                )}
                              </button>
                            
                          ) : (
                            ""
                          )}

                          
                        </div>
                      </td>
                    )}
                    {handleViewDetails  && (
                      <>
                        <td >
                          <div className="text-center">
                          
                            <button
                              key={`repView_${rowIndex}`}
                              onClick={() => handleViewReport(rowIndex)}
                              className="border-white no-bg text-blue"
                            >
                              <FcViewDetails title="View Detail Report" />
                              
                            </button>
                          </div>
                        </td>
                      </>
                    )}
                    {handleClickDownloadFlag ? (
                      <>
                        <td>
                          <div className="btn-wrapper no-wrap">
                            <button
                              type="button"
                              className="btn-sm btn-blue"
                              onClick={(e) =>
                                handleLogDownload(
                                  tableData[rowIndex]?.filesLink
                                )
                              }
                            >
                              Click To Download{" "}
                            </button>
                          </div>
                        </td>
                      </>
                    ) : (
                      ""
                    )}
                  </tr>
                );
              })}
            </tbody>
          ) : (
            <tbody>
              <tr>
                <td
                  colSpan={
                    action ? tableColumns.length + 1 : tableColumns.length
                  }
                  align="center"
                  className="text-red "
                >
                  <b>{"No Data to Show"}</b>
                </td>
              </tr>
            </tbody>
          )}
        </table>
      </div>
      {handlePaginationButtons ? (
        <>
          <div className="row p-5 bg-dim-white">
            <div className="col-md-6 p-5 text-gray text-semi-bold">
              {`Showing ${totalLimit ? lowerLimit : 0} - ${
                upperLimit > totalLimit ? totalLimit : upperLimit
              } of ${totalLimit} Items`}
            </div>
            <div className="col-md-6 text-right">
              <button
                onClick={() => handlePageChange(ACTION_FIRST)}
                disabled={!canPrev}
                title="Go To First Page"
                className={`btn btn-sm btn-no-outline-${
                  !canPrev ? "red" : "green"
                } ml-10`}
              >
                <FaAngleDoubleLeft />
              </button>

              <button
                onClick={() => handlePageChange(ACTION_PREV)}
                disabled={!canPrev}
                title="Prev"
                className={`btn btn-sm btn-no-outline-${
                  !canPrev ? "red" : "green"
                } ml-10`}
              >
                <FaAngleLeft />
              </button>

              <button
                onClick={() => handlePageChange(ACTION_NEXT)}
                disabled={!canNext}
                title="Next"
                className={`btn btn-sm btn-no-outline-${
                  !canNext ? "red" : "green"
                } ml-10`}
              >
                <FaAngleRight />
              </button>

              <button
                onClick={() => handlePageChange(ACTION_LAST)}
                disabled={!canNext}
                title="Go to Last Page"
                className={`btn btn-sm btn-no-outline-${
                  !canNext ? "red" : "green"
                } ml-10`}
              >
                <FaAngleDoubleRight />
              </button>
            </div>
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
}
